import { useContext, FC } from "react"
import { Controller } from "react-hook-form"
import { ProposalFormContext } from "../../proposals.context"
import { ProductMenu } from "../product-menu.view"
import type { ProductKind } from "~/proposals/models/product.model"

type Props = {
  excludeProductKinds?: ProductKind[]
}

export const ProductKindField: FC<Props> = ({ excludeProductKinds = [] }) => {
  const { control } = useContext(ProposalFormContext)

  return (
    <Controller
      control={control}
      name="product.kind"
      render={({ field: { onChange } }) => {
        return (
          <ProductMenu
            onChange={onChange}
            excludeProductKinds={excludeProductKinds}
          />
        )
      }}
    />
  )
}
